import React, { useEffect, useState, Suspense } from 'react'
import { useSelector, } from 'react-redux'
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ReactGA from 'react-ga';
import Home from './Screens/Home'
import AboutUs from './Screens/AboutUS'
import DoctorTeam from './Screens/DoctorTeam/DoctorTeam'
import DoctorInfo from './Screens/DoctorTeam/DoctorInfo'
import AllReview from './Screens/AllReview'
import Blog from './Screens/Blog'
import BlogInfo from './Screens/BlogInfo'
import ContactUs from './Screens/ContactUs'
import DiseaseAll from './Screens/Disease/DiseaseAll'
import AllergicRhinitis from './Screens/Disease/AllergicRhinitis'
import Dyspnea from './Screens/Disease/Dyspnea'
import Hepatitis from './Screens/Disease/Hepatitis'
import Cancer from './Screens/Disease/Cancer'
import Autism from './Screens/Disease/Autism'
import AnorexiaNervosa from './Screens/Disease/AnorexiaNervosa'
import Chickenpox from './Screens/Disease/Chickenpox'
import NotFoundRoute from './Components/Other/NotFoundRoute'
import Deafness from './Screens/Disease/Deafness'
import Anemia from './Screens/Disease/Anemia'
import Piles from './Screens/Disease/Piles'
import BulimiaNervosa from './Screens/Disease/BulimiaNervosa'
import Measle from './Screens/Disease/Measle'
import Mumps from './Screens/Disease/Mumps'
import SystemicLupusErythematosus from './Screens/Disease/SystemicLupusErythematosus'
import PlicaPolonica from './Screens/Disease/PlicaPolonica'
import CrohnDisease from './Screens/Disease/CrohnDisease'
import Hypercholesterolemia from './Screens/Disease/Hypercholesterolemia'
import ChronicObstructivePulmonary from './Screens/Disease/ChronicObstructivePulmonary'
import Croup from './Screens/Disease/Croup'
import Pleurisy from './Screens/Disease/Pleurisy'
import CommonCold from './Screens/Disease/CommonCold'
import Onycomycosis from './Screens/Disease/Onycomycosis'
import Paronychia from './Screens/Disease/Paronychia'
import Hyperhydrosis from './Screens/Disease/Hyperhydrosis'
import Epistexis from './Screens/Disease/Epistexis'
import Sunburn from './Screens/Disease/sunburn'
import Chilblains from './Screens/Disease/Chilblains'
import VaricoseVein from './Screens/Disease/VaricoseVein'
import Gingivitis from './Screens/Disease/Gingivitis'
import Cholera from './Screens/Disease/Cholera'
import Gangren from './Screens/Disease/Gangren'
import NeurogenicBladder from './Screens/Disease/NeurogenicBladder'
import UrinaryIncontinence from './Screens/Disease/UrinaryIncontinence'
import Cystocele from './Screens/Disease/Cystocele'
import TenisElbow from './Screens/Disease/TenisElbow'
import StudentElbow from './Screens/Disease/StudentElbow'
import Toothache from './Screens/Disease/Toothache'
import TrigeminalNeuralgia from './Screens/Disease/TrigeminalNeuralgia'
import Wounds from './Screens/Disease/Wounds'
import Appendix from './Screens/Disease/Appendix'
import WritersCramp from './Screens/Disease/WritersCramp'
import Trauma from './Screens/Disease/Trauma'
import DiabeticFoot from './Screens/Disease/DiabeticFoot'
import NonHealingUlcer from './Screens/Disease/NonHealingUlcer'
import NonUnionOfBone from './Screens/Disease/NonUnionOfBone'
import Dyslexia from './Screens/Disease/Dyslexia'
import IdiopathicThrombocytopenicPurpura from './Screens/Disease/IdiopathicThrombocytopenicPurpura'
import Dermatitis from './Screens/Disease/Dermatitis'
import AnalFissure from './Screens/Disease/AnalFissure'
import Menieres from './Screens/Disease/Menieres'
import PuerperalPsychosis from './Screens/Disease/PuerperalPsychosis'
import Gallery from './Screens/Gallery'

import MakeAppointmnet from './Screens/MakeAppointmnet'
import AppointmentHistory from './Screens/AppointmentHistory'
import Event from './Screens/Event'
import EventInfo from './Screens/EventInfo'
import Careers from './Screens/Careers'
import NutritionAndWellness from './Screens/NutritionAndWellness'
import HFC from './Screens/HFC'
import TermsAndConditions from './Screens/TermsAndConditions'
import PrivacyPolicy from './Screens/PrivacyPolicy'
import RefundsNCancellation from './Screens/RefundsNCancellation'
const basename = ""

export const routes = {
    home: basename + "/",
    about: basename + '/about-us',
    team: basename + '/doctor-team',
    blog: basename + '/rnd',    //blog is rnd
    event: basename + '/event',
    careers: basename + '/careers',
    contact: basename + "/contact-us",
    disease: basename + '/all-disease',
    Gallery:basename+"/gallery",
    makeAppointmnet: basename + '/make-appointment',
    allergic: basename + '/all-disease/allergic-rhinitis',
    dyspnea: basename + '/all-disease/dyspnea',
    hepatitis: basename + '/all-disease/hepatitis',
    cancer: basename + '/all-disease/cancer',
    autism: basename + '/all-disease/autism',
    anorexiaNervosa: basename + '/all-disease/anorexia-nervosa',
    chickenpox: basename + '/all-disease/chickenpox',
    deafness: basename + '/all-disease/deafness',
    anemia: basename + '/all-disease/anemia',
    piles: basename + '/all-disease/piles',
    BulimiaNervosa: basename + '/all-disease/bulimia-nervosa',
    Measle: basename + '/all-disease/measle',
    Mumps: basename + '/all-disease/mumps',
    SystemicLupusErythematosus: basename + '/all-disease/systemic-lupus-erythematosus',
    PlicaPolonica: basename + '/all-disease/plica-polonica',
    CrohnDisease: basename + '/all-disease/crohnDisease',
    Hypercholesterolemia: basename + '/all-disease/hypercholesterolemia',
    ChronicObstructivePulmonary: basename + '/all-disease/chronic-obstructive-pulmonary',
    Croup: basename + '/all-disease/croup',
    Pleurisy: basename + '/all-disease/Pleurisy',
    CommonCold: basename + '/all-disease/commonCold',
    Onycomycosis: basename + '/all-disease/onycomycosis',
    Paronychia: basename + '/all-disease/paronychia',
    Hyperhydrosis: basename + '/all-disease/hyperhydrosis',
    Epistexis: basename + '/all-disease/epistexis',
    Sunburn: basename + '/all-disease/sunburn',
    Chilblains: basename + '/all-disease/chilblains',
    VaricoseVein: basename + '/all-disease/varicoseVein',
    Gingivitis: basename + '/all-disease/gingivitis',
    Cholera: basename + '/all-disease/cholera',
    Gangren: basename + "/all-disease/gangren",
    NeurogenicBladder: basename + '/all-disease/neurogenic-bladder',
    UrinaryIncontinence:basename+'/all-disease/urinary-incontinence',
    Cystocele:basename+'/all-disease/Cystocele',
    TenisElbow:basename+'/all-disease/tenis-elbow',
    StudentElbow:basename+'/all-disease/student-elbow',
    Toothache:basename+'/all-disease/toothache',
    TrigeminalNeuralgia:basename+'/all-disease/trigeminal-neuralgia',
    Wounds:basename+'/all-disease/wounds',
    Appendix:basename+'/all-disease/appendix',
    WritersCramp:basename+'/all-disease/writers-cramp',
    Trauma:basename+'/all-disease/trauma',
    DiabeticFoot:basename+'/all-disease/diabetic-foot',
    NonHealingUlcer:basename+"/all-disease/non-healing-ulcer",
    NonUnionOfBone:basename+"/all-disease/non-union-of-bone",
    Dyslexia:basename+"/all-disease/dyslexia",
    IdiopathicThrombocytopenicPurpura:basename+'/all-disease/idiopathic-thrombocytopenic-purpura',
    Dermatitis:basename+'/all-disease/dermatitis',
    AnalFissure:basename+'/all-disease/anal-fissure',
    Menieres:basename+'/all-disease/menieres',
    PuerperalPsychosis:basename+'/all-disease/puerperal-psychosis',

   

    AppointmentHistory: '/appointment-history',
    AllReview: basename + '/all_review_list',
    NutritionAndWellness: basename + '/nutrition-n-wellness',
    HFC: basename + '/hfc',
    TermsAndConditions:basename+"/terms-and-conditions",
    PrivacyPolicy:basename+"/privacy-policy",
    RefundsNCancellation:basename+"/refunds-and-cancellation"
    // TankYouPage: "/TankYouPage",
    // SetAppointmentTime: "/SetAppointmentTime",

    // UpdatePatientInfo: '/paitent-info',
    // ResheduleTime: '/appointment-reshedule',
    // PaymentSuccess: '/Payment/success',
    // PaymentFail: '/Payment/fail',
};


function MainPage(props) {

    const data = useSelector((state) => state)
    const [offset, setOffset] = useState(0);
//UA-147951599-1

    useEffect(() => {
        
        ReactGA.pageview(window.location.pathname + window.location.search);
        const onScroll = () => {
            window.pageYOffset > 0 ? document.body.classList.add('headerFixed') : document.body.classList.remove('headerFixed');

        }
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    return (<>

        <BrowserRouter >

            <Routes>
                <Route index path={routes.home} element={<Home />} />
                <Route path={routes.about} element={<AboutUs />} />
                <Route path={routes.team} element={<DoctorTeam />} ></Route>
                <Route path={routes.team + "/:name"} element={<DoctorInfo />} />
                <Route path={routes.blog} element={<Blog />} />
                <Route path={routes.blog + "/:name"} element={<BlogInfo />} />
                <Route path={routes.AllReview} element={<AllReview />} />
                <Route path={routes.event} element={<Event />} />
                <Route path={routes.event + "/:name"} element={<EventInfo />} />
                
                <Route path={routes.Gallery} element={<Gallery />} />
                <Route path={routes.careers} element={<Careers />} />
                <Route path={routes.contact} element={<ContactUs />} />
                <Route path={routes.makeAppointmnet} element={<MakeAppointmnet />} />
                <Route path={routes.disease} element={<DiseaseAll />}></Route>
                <Route path={routes.allergic} element={<AllergicRhinitis />} />
                <Route path={routes.dyspnea} element={<Dyspnea />} />
                <Route path={routes.hepatitis} element={<Hepatitis />} />
                <Route path={routes.cancer} element={<Cancer />} />
                <Route path={routes.autism} element={<Autism />} />
                <Route path={routes.anorexiaNervosa} element={<AnorexiaNervosa />} />
                <Route path={routes.chickenpox} element={<Chickenpox />} />
                <Route path={routes.deafness} element={<Deafness />} />
                <Route path={routes.anemia} element={<Anemia />} />
                <Route path={routes.piles} element={<Piles />} />
                <Route path={routes.BulimiaNervosa} element={<BulimiaNervosa />} />
                <Route path={routes.Measle} element={<Measle />} />
                <Route path={routes.Mumps} element={<Mumps />} />
                <Route path={routes.SystemicLupusErythematosus} element={<SystemicLupusErythematosus />} />
                <Route path={routes.PlicaPolonica} element={<PlicaPolonica />} />
                <Route path={routes.CrohnDisease} element={<CrohnDisease />} />
                <Route path={routes.Hypercholesterolemia} element={<Hypercholesterolemia />} />
                <Route path={routes.ChronicObstructivePulmonary} element={<ChronicObstructivePulmonary />} />
                <Route path={routes.Croup} element={<Croup />} />
                <Route path={routes.Pleurisy} element={<Pleurisy />} />
                <Route path={routes.CommonCold} element={<CommonCold />} />
                <Route path={routes.Onycomycosis} element={<Onycomycosis />} />
                <Route path={routes.Paronychia} element={<Paronychia />} />
                <Route path={routes.Hyperhydrosis} element={<Hyperhydrosis />} />
                <Route path={routes.Epistexis} element={<Epistexis />} />
                <Route path={routes.Sunburn} element={<Sunburn />} />
                <Route path={routes.Chilblains} element={<Chilblains />} />
                <Route path={routes.VaricoseVein} element={<VaricoseVein />} />
                <Route path={routes.Gingivitis} element={<Gingivitis />} />
                <Route path={routes.Cholera} element={<Cholera />} />
                <Route path={routes.Gangren} element={<Gangren />} />
                <Route path={routes.NeurogenicBladder} element={<NeurogenicBladder/>}/>
                <Route path={routes.UrinaryIncontinence} element={<UrinaryIncontinence/>}/>
                <Route path={routes.Cystocele} element={<Cystocele/>}/>
                <Route path={routes.TenisElbow} element={<TenisElbow/>}/>
                <Route path={routes.StudentElbow} element={<StudentElbow/>}/>
                <Route path={routes.Toothache} element={<Toothache/>}/>
                <Route path={routes.TrigeminalNeuralgia} element={<TrigeminalNeuralgia/>}/>
                <Route path={routes.Wounds} element={<Wounds/>}/>
                <Route path={routes.Appendix} element={<Appendix/>}/>
                <Route path={routes.WritersCramp} element={<WritersCramp/>}/>
                <Route path={routes.Trauma} element={<Trauma/>}/>
                <Route path={routes.DiabeticFoot} element={<DiabeticFoot/>}/>
                <Route path={routes.NonHealingUlcer} element={<NonHealingUlcer/>}/>
                <Route path={routes.NonUnionOfBone} element={<NonUnionOfBone/>}/>
                <Route path={routes.Dyslexia} element={<Dyslexia/>}/>
                <Route path={routes.IdiopathicThrombocytopenicPurpura} element={<IdiopathicThrombocytopenicPurpura/>}/>
                <Route path={routes.Dermatitis} element={<Dermatitis/>}/>
                <Route path={routes.AnalFissure} element={<AnalFissure/>}/>
                <Route path={routes.Menieres} element={<Menieres/>}/>
                <Route path={routes.PuerperalPsychosis} element={<PuerperalPsychosis/>}/>
                 {/* <Route path={routes.VaricoseVein} element={<VaricoseVein/>}/> */}
                {/* <Route path={routes.VaricoseVein} element={<VaricoseVein/>}/> */}
                {/* <Route path={routes.VaricoseVein} element={<VaricoseVein/>}/> */}
                {/* <Route path={routes.VaricoseVein} element={<VaricoseVein/>}/> */}

                <Route path="*" element={<NotFoundRoute />} />
                <Route path={routes.AppointmentHistory + "/:id"} element={<AppointmentHistory />} />
                <Route path={routes.NutritionAndWellness} element={<NutritionAndWellness />} />
                <Route path={routes.HFC} element={<HFC />} />
                <Route path={routes.TermsAndConditions} element={<TermsAndConditions />} />
                <Route path={routes.PrivacyPolicy} element={<PrivacyPolicy />} />
                <Route path={routes.RefundsNCancellation} element={<RefundsNCancellation />} />
                
                {/* <Route path={routes.AppointmentHistory + "/:id"} element={<AppointmentHistory />} />
                <Route path={routes.AppointmentHistory + "/:id" + routes.UpdatePatientInfo} element={<UpdatePatientInfo />} />
                <Route path={routes.AppointmentHistory + "/:id" + routes.ResheduleTime} element={<ResheduleTime />} />
                <Route path={routes.PaymentSuccess} element={<PaymentSuccess />} />
                <Route path={routes.PaymentFail} element={<PaymentFail />} />
                <Route path="*" element={<NotFoundRoute />} /> */}
            </Routes>

        </BrowserRouter>
    </>
    )
}
export default (MainPage);
